import React, { useState } from "react";
import { MenuPerview } from "./NewHeaderRenderer";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";

const NewHeaderRendererMobile = ({ headerConfig }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="mobile-top-navbar">
      <div className="mobile_menu_icon">
        <MaterialIcon name="menu" onClick={() => setIsMenuOpen(true)} />
      </div>
      {isMenuOpen && (
        <div className="mobile-preview-navbar">
          <div className="mobile-navbar-top">
            <div className="ml_auto">
              <MaterialIcon
                name="close"
                className="mobile-nav-close-icon"
                onClick={() => setIsMenuOpen(false)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
          <MenuPerview headerConfig={headerConfig} />
        </div>
      )}
    </div>
  );
};

export default NewHeaderRendererMobile;
